import { connect } from 'react-redux';
import { ProviderAvailabilityTooltipView } from './ProviderAvailabilityTooltip';
import withAB from '../../../../config/ab/withAB';
import { PINA_PROVIDER_AVAILABILITY_TOOLTIP } from '../../../../config/ab/experiments';
import { mapStateToProps } from './mapStateToProps';

const ProviderAvailabilityTooltip = withAB(PINA_PROVIDER_AVAILABILITY_TOOLTIP)(
    connect(mapStateToProps)(ProviderAvailabilityTooltipView)
);

export {
    ProviderAvailabilityTooltip as default,
    ProviderAvailabilityTooltip,
};
